export default __webpack_public_path__ + "static/logo-rgb-e2cc53046160598e7c8e06177f339e47.svg";